<template>
  <div class="loginform">
    <div class="login">
      <div class="logo">
        <img src="@/assets/images/logo.svg" />
      </div>
      <div class="title" :class="{ 'text-danger': textDanger }">
        {{ loginMsg }}
      </div>
    </div>
  </div>
</template>

<script>
import { config } from "@/config/index";
import { getQueryVariable } from "@/utils/index";
export default {
  name: "LoginFromPc",
  data() {
    return {
      textDanger: false,
      loginMsg: "欢迎登录，正在校验身份...",
      temp_token: "",
      redirect: "",
    };
  },
  created() {
    // 如果携带了redirect，登录后将跳转到对应的链接
    this.redirect = this.$route.query.redirect;
    if (this.$route.query.token) {
      // 直接从url中获取token
      this.temp_token = this.$route.query.token;
    } else {
      // 从redirect中解析出token参数
      const myURL = new URL(this.redirect);
      this.temp_token = getQueryVariable(myURL, "token");
    }
    if (this.temp_token) {
      this.loginFromPc();
    } else {
      this.textDanger = true;
      this.loginMsg = "登录失败，参数获取失败";
    }
  },
  methods: {
    loginFromPc() {
      this.$store
        .dispatch("LoginFromPc", this.temp_token)
        .then((res) => {
          if (res.status_code === 200) {
            if (this.redirect) {
              window.location.href = this.redirect;
            } else {
              this.$router.push({ name: "persona" });
            }
          } else {
            this.textDanger = true;
            this.loginMsg = "用户校验失败，正在跳转到登录页...";
            setTimeout(() => {
              // this.$router.push({ name: "login" });
              const routeUrl = this.$router.resolve({
                name: "login_terminal",
              });
              window.location.href =
                `${config.loginUrl}` +
                encodeURIComponent(`${window.location.origin}${routeUrl.href}`);
            }, 3000);
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.textDanger = true;
          this.loginMsg = "用户校验出错";
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
  },
};
</script>

<style scoped>
.login {
  min-height: 200px;
  margin-top: -100px;
}
@media (max-width: 768px) {
  .login {
    width: 100%;
    height: 200px;
    position: absolute;
    top: 35%;
    left: 0;
    margin: 0;
    padding: 50px 40px;
  }
}
</style>